import React from "react";
import ThanksPng from "../assests/thank_you.png";
import "../App.css";
import SurveyStatusPage from "../components/question-components/survey-status";

const Terminate = () => {
  return <SurveyStatusPage status="terminated" />;
};

export default Terminate;
